import { useCallback, useEffect, useRef, useState } from 'react'

import { trpc } from '../../lib/trpc'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog'
import { SmsCaptchaWidget } from './sms-captcha-widget'

export function useSmsCaptcha() {
  const utils = trpc.useUtils()
  const [siteKey, setSiteKey] = useState<string | null>(null)
  const pending = useRef<{
    resolve: (token: string) => void
    reject: (error: Error) => void
  } | null>(null)
  const onError = useCallback((error: Error) => {
    pending.current?.reject(error)
    pending.current = null
    setSiteKey(null)
  }, [])
  const onToken = useCallback((token: string) => {
    pending.current?.resolve(token)
    pending.current = null
    setSiteKey(null)
  }, [])
  const requestToken = useCallback(async () => {
    if (pending.current) throw new Error('Une vérification de sécurité est déjà en cours.')
    return new Promise<string>((resolve, reject) => {
      pending.current = { resolve, reject }
      void utils.userAuth.smsCaptchaConfig
        .fetch()
        .then((config) => {
          if (pending.current) setSiteKey(config.siteKey)
        })
        .catch((error: unknown) => {
          onError(error instanceof Error ? error : new Error('Vérification indisponible.'))
        })
    })
  }, [utils, onError])
  useEffect(
    () => () => {
      pending.current?.reject(new Error('Vérification de sécurité annulée.'))
      pending.current = null
    },
    []
  )
  const captchaDialog = (
    <Dialog
      open={siteKey !== null}
      onOpenChange={(open) => {
        if (!open) onError(new Error('Vérification de sécurité annulée.'))
      }}
    >
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Vérification de sécurité</DialogTitle>
        </DialogHeader>
        {siteKey && <SmsCaptchaWidget siteKey={siteKey} onToken={onToken} onError={onError} />}
      </DialogContent>
    </Dialog>
  )
  return { requestToken, captchaDialog }
}
